import { useMemo, useState } from "react";
import PropTypes from "prop-types";

import { strCode } from "../../../../../../consts";
import { t } from "../../../../../../services";

import { DropdownInput, FlexContainers, IconButton, SVG } from "../../../../../../components";
import { Circle, DropdownInputWrapper, VersionSelectorContainer } from "./styled";
import { versionOptionUtils } from "../../utils/versionOptionsUtils";

export const FWUVersionSelector = ({
  id,
  version,
  versionOptions,
  prevVersion,
  nextVersion,
  handleSelectVersion,
  handleDeleteVersion,
  hasError,
  showErrors,
  disabled
}) => {
  const [selectedVersion, setSelectedVersion] = useState(version);

  const filteredVersionOptions = useMemo(() => {
    return versionOptionUtils.filterVersionOptions(versionOptions, prevVersion, nextVersion)
  }, [versionOptions, prevVersion, nextVersion]);

  const onSelectOption = (optId) => {
    const newSelectedVersion = versionOptions.find((opt) => opt.id === optId);

    setSelectedVersion(newSelectedVersion);
    handleSelectVersion(id, newSelectedVersion);
  };

  return (
    <VersionSelectorContainer>
      <Circle />
      <DropdownInputWrapper Container={FlexContainers.FlexRowCenter} gap={16} width={"100%"}>
        <DropdownInput
          id={`fwu-version-selector-${id}`}
          title={t(strCode.SELECT_FW_VERSION_TITLE)}
          placeholder={t(strCode.SELECT_PLACEHOLDER)}
          options={filteredVersionOptions}
          selectedOption={selectedVersion}
          onSelectOption={onSelectOption}
          hasError={showErrors && hasError}
          disabled={disabled}
        />

        {handleDeleteVersion && (
          <IconButton onClick={() => handleDeleteVersion(id)}>
            <SVG.DeleteIcon />
          </IconButton>
        )}
      </DropdownInputWrapper>
    </VersionSelectorContainer>
  );
};

FWUVersionSelector.propTypes = {
  id: PropTypes.string.isRequired,
  version: PropTypes.shape({ id: PropTypes.string.isRequired, value: PropTypes.string.isRequired }),
  versionOptions: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string.isRequired, value: PropTypes.string.isRequired })
  ).isRequired,
  prevVersion: PropTypes.string,
  nextVersion: PropTypes.string,
  handleSelectVersion: PropTypes.func.isRequired,
  handleDeleteVersion: PropTypes.func,
  hasError: PropTypes.bool.isRequired,
  showErrors: PropTypes.bool.isRequired,
  disabled: PropTypes.bool
};
